import { registerLocale } from 'react-datepicker';
import { enUS, hy, ru } from 'date-fns/locale';
import { Language } from '../consts/locale';

// react-datepicker keeps one global locale registry, so registering here (on
// first import) covers every picker in the app.
registerLocale(Language.En, enUS);
registerLocale(Language.Hy, hy);
registerLocale(Language.Ru, ru);

/**
 * Locale name to hand to <DatePicker locale={...} /> so the calendar follows
 * the language picked in the sidebar-header. Falls back to English.
 */
export const datePickerLocale = locale =>
	locale === Language.Hy || locale === Language.Ru ? locale : Language.En;
